<div #container style="position: relative;" [ngClass]="{'border-red': formInvalid}">
  <angular2-multiselect [data]="dropdownList"
    [loading] = "loading"
    [settings]="dropdownSettings"
    [(ngModel)]="selectedItems"
    (onOpen)="onOpen($event)"
    (onSelect)="onItemSelect($event)"
    (onDeSelect)="OnItemDeSelect($event)"
    (onSelectAll)="onSelectAll($event)"
    (onDeSelectAll)="onDeSelectAll($event)"
    (onClose)="onClose($event)"
    (onScrollToEnd)="fetchMore($event)" >
    <c-item>
      <ng-template let-item="item">
          <ng-container *ngIf="item.dailyWithdrawalValue; else plainLabel">
            <div class="d-inline-flex align-items-center">
              <i class="fa fa-exclamation-circle mr-2" [ngClass]="item.dailyWithdrawalClass"></i>
              <span>
                <label class="mb-0 d-block">{{item[dropdownSettings.labelKey]}}</label>
                <span class="small d-block">Used: <span [ngClass]="item.dailyWithdrawalClass">{{item.dailyWithdrawalValue}}</span></span>
              </span>
            </div>
          </ng-container>
          <ng-template #plainLabel>
            <label>{{item[dropdownSettings.labelKey]}}</label>
          </ng-template>
      </ng-template>
    </c-item>
  </angular2-multiselect>

  <div *ngIf="(selectedItems == undefined || selectedItems.length == 0) && dataLoading" style="position: absolute; right: 30px; top: 0px;" class="text-right">
    <i class='spinner-border spinner-border-sm align-middle' [ngStyle]="{'margin-top': (container.offsetHeight / 3) + 'px'}"></i>
  </div>
</div>